import { css } from "@styled-system/css";
import { flex } from "@styled-system/patterns";

export const wrapperClass = flex({
	direction: "column",
	alignItems: "flex-start",
	gap: "12",
});

export const hintClass = css({
	fontSize: "12",
	color: "shade.60",
});

export const reasonFieldClass = css({
	width: "full",
	marginBottom: "12",
});

export const dialogFooterClass = flex({
	justifyContent: "flex-end",
	gap: "8",
});
